import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dynamic%20sports%20background%20with%20geometric%20shapes%20and%20flowing%20lines%20in%20warm%20orange%20and%20teal%20tones%20modern%20minimalist%20design%20clean%20aesthetic%20soft%20gradient%20artistic%20style%20high%20contrast&width=1600&height=900&seq=hero-bg-sports-2024&orientation=landscape"
        alt="体育App推荐与下载指南"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white text-xs md:text-sm font-medium mb-6 whitespace-nowrap">
            2024年最全体育App推荐
          </span>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
            找到最适合你的<strong className="text-accent-300">体育App</strong>
          </h1>
          <p className="text-sm md:text-base text-white/75 max-w-xl mx-auto mb-8 leading-relaxed">
            汇集热门体育App下载、功能对比与使用攻略，覆盖赛事直播、运动记录、竞猜互动等核心功能，帮助球迷与运动爱好者快速找到最适合自己的体育App
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/saishi-zhibo"
              className="w-full sm:w-auto px-8 py-3 bg-accent-500 hover:bg-accent-600 text-white font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
            >
              探索热门App
            </Link>
            <Link
              to="/category/yundong-jilu"
              className="w-full sm:w-auto px-8 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-white/25 rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
            >
              查看分类
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}